module.exports = __webpack_public_path__ + "static/media/nourish.5eb9f070.png";